import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { DaDataResponse } from '@company/const';
import { CompanyService } from '@company/feature';
import { InputAutocompleteItem } from '@shared/models';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';

@Component({
  selector: 'sd-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdAddCompanyComponent implements OnInit, OnDestroy {
  result$: Observable<InputAutocompleteItem<DaDataResponse>[]>;

  searchCompanyLoading$: Observable<boolean>;
  addCompanyLoading$: Observable<boolean>;
  userCompaniesLoading$: Observable<boolean>;

  inputEnteredValue$ = new Subject<string>();
  inputSelectedValue$ = new BehaviorSubject<DaDataResponse>(undefined);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit = new EventEmitter();

  private subscription = new Subscription();

  constructor(private companyService: CompanyService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.inputEnteredValue$
        .pipe(
          debounceTime(600),
          filter((query) => query.length > 2),
        )
        .subscribe((query) => {
          this.companyService.searchCompany(query);
        }),
    );

    this.addCompanyLoading$ = this.companyService.getAddCompanyLoading();
    this.searchCompanyLoading$ = this.companyService.getSearchCompanyLoading();
    this.userCompaniesLoading$ = this.companyService.getUserCompaniesLoading();

    this.result$ = this.companyService
      .getSearchCompanyResult()
      .pipe(map((res) => res.map((item) => ({ label: item.name, value: item }))));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.companyService.resetSearchCompanyResult();
  }

  onAddCompanyBtnClick(data: DaDataResponse): void {
    if (!this.inputSelectedValue$.getValue()) {
      return;
    }

    this.submit.emit();

    this.companyService.addCompany({
      name: data.name,
      inn: data.vatID,
      kpp: data.debtorKPP,
      ogrn: data.debtorOGRN,
      // Для обратной совместимости оставлен formattedAddress
      address: { ...(data.address || {}), formattedAddress: data.contactAddress },
    });
  }
}
